/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { type GenericATGErrorData } from '@/config/types';
import { isAxiosError } from './isAxiosError';

export function getErrorDetails(error: unknown): GenericATGErrorData['errorDetails'] | undefined {
  if (isAxiosError<GenericATGErrorData>(error)) {
    return error.response?.data.errorDetails;
  }
}
